/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { IExample } from '../../../core/models/common/IExample';
import { INamed } from '../../../core/models/common/INamed';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class Oas30Example extends ExtensibleNode implements IReferenceNode, INamed, IExample {
    /*private*/ _name : string;

    public $ref : string;

    public summary : string;

    public description : string;

    public value : any;

    public externalValue : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.$ref===undefined) this.$ref = null;
        if(this.summary===undefined) this.summary = null;
        if(this.description===undefined) this.description = null;
        if(this.value===undefined) this.value = null;
        if(this.externalValue===undefined) this.externalValue = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * 
     * @return {*}
     */
    public getValue() : any {
        return this.value;
    }

    /**
     * 
     * @param {*} value
     */
    public setValue(value : any) {
        this.value = value;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitExample(this);
    }
}
Oas30Example["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Example";
Oas30Example["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExample","io.apicurio.datamodels.core.models.common.INamed"];




